module.exports = __webpack_public_path__ + "static/media/212.c3093063.png";